import React, { Component } from 'react';
import Page from '../containers/page';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { Container, Row, Col } from 'reactstrap';

import AccountNav from '../components/accountNav';
import Text from '../components/forms/fields/text';
import Check from '../components/forms/fields/check';
import Select from '../components/forms/fields/select';
import DatePicker from '../components/forms/fields/date';
import { API_ENDPOINT } from '../constants';

import image from '../assets/images/account-cover.png';
import imageMobile from '../assets/images/account-cover.png';

const IPV4_OCTET = '(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d|0)';
const IPV4_REGEX = new RegExp(`^${IPV4_OCTET}(\\.${IPV4_OCTET}){3}$`);
const IPV4_CIDR_REGEX = new RegExp(
  `^${IPV4_OCTET}(\\.${IPV4_OCTET}){3}/(3[0-2]|[12]?\\d)$`,
);
const IPV6_REGEX =
  /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;

function isValidIpEntry(value) {
  const v = (value || '').trim();
  if (!v) return false;
  return (
    IPV4_REGEX.test(v) || IPV4_CIDR_REGEX.test(v) || IPV6_REGEX.test(v)
  );
}

function isIpListNarrowed(oldIps, newIps) {
  oldIps = oldIps || [];
  newIps = newIps || [];
  if (JSON.stringify(oldIps) === JSON.stringify(newIps)) return false;
  if (oldIps.length === 0 && newIps.length > 0) return true;
  return oldIps.some((ip) => newIps.indexOf(ip) === -1);
}

function formatRemaining(ms) {
  const minutes = Math.max(0, Math.round(ms / 60000));
  if (minutes < 60) return minutes + ' min';
  if (minutes < 1440) return Math.round(minutes / 60) + ' h';
  return Math.round(minutes / 1440) + ' d';
}

function getKeyStatus(key, now) {
  const revokedAt = key.revokedAt ? new Date(key.revokedAt).getTime() : null;
  const expiresAt = key.expiresAt ? new Date(key.expiresAt).getTime() : null;

  if (revokedAt !== null && revokedAt <= now) {
    return { code: 'revoked', label: 'Återkallad', className: 'status-gray' };
  }
  if (revokedAt !== null && revokedAt > now) {
    return {
      code: 'expiring',
      label: 'Upphör snart (roterad)',
      className: 'status-orange',
      remaining: formatRemaining(revokedAt - now),
    };
  }
  if (expiresAt !== null && expiresAt <= now) {
    return { code: 'expired', label: 'Utgången', className: 'status-red' };
  }
  if (!key.isEnabled) {
    return {
      code: 'disabled',
      label: 'Inaktiverad',
      className: 'status-yellow',
    };
  }
  return { code: 'active', label: 'Aktiv', className: 'status-green' };
}

function maskKey(key) {
  return 'vd_live_' + key.prefix + '_••••••••';
}

class AccountApiKeysPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.initialData,
      keys: [],
      loading: true,
      listError: null,
      showRevoked: false,
      now: Date.now(),
      successMessage: null,

      createModalOpen: false,
      createName: '',
      createIps: [],
      createIpInput: '',
      createIpError: null,
      createExpiresAt: null,
      createEnabled: true,
      createSubmitting: false,
      createError: null,

      revealKey: null,
      revealContext: null,
      revealSaved: false,
      revealCopied: false,

      editKey: null,
      editName: '',
      editIps: [],
      editIpInput: '',
      editIpError: null,
      editExpiresAt: null,
      editEnabled: true,
      editSubmitting: false,
      editError: null,
      editNeedsConfirm: false,

      rotateKey: null,
      rotateGrace: 1440,
      rotateSubmitting: false,
      rotateError: null,

      revokeKey: null,
      revokeConfirmInput: '',
      revokeSubmitting: false,
      revokeError: null,
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }

    this.get();

    this.tickInterval = setInterval(() => {
      this.setState({ now: Date.now() });
    }, 30000);
  }

  componentWillUnmount() {
    if (this.tickInterval) {
      clearInterval(this.tickInterval);
    }
  }

  apiFetch = (path, options) => {
    options = options || {};
    return fetch(API_ENDPOINT + path, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        ...(options.headers || {}),
      },
    }).then((res) => {
      if (res.status === 401) {
        this.props[0].history.push('/account');
        throw new Error('unauthorized');
      }

      return res.json().then((json) => ({ status: res.status, json }));
    });
  };

  get = () => {
    this.setState({ loading: true });

    return this.apiFetch('/account/api-keys')
      .then(({ json }) => {
        this.setState({
          keys: Array.isArray(json) ? json : [],
          loading: false,
          listError: null,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showSuccess = (message) => {
    this.setState({ successMessage: message });
    if (this.successTimeout) clearTimeout(this.successTimeout);
    this.successTimeout = setTimeout(() => {
      this.setState({ successMessage: null });
    }, 5000);
  };

  activeKeyCount = () => {
    return this.state.keys.filter((key) => {
      const revokedAt = key.revokedAt
        ? new Date(key.revokedAt).getTime()
        : null;
      return !(revokedAt !== null && revokedAt <= this.state.now);
    }).length;
  };

  // ---------- IP chip input (shared by create/edit) ----------

  addIp = (scope) => {
    const inputKey = scope + 'IpInput';
    const listKey = scope + 'Ips';
    const errorKey = scope + 'IpError';

    const value = this.state[inputKey].trim().replace(/,$/, '');
    if (!value) return;

    if (!isValidIpEntry(value)) {
      this.setState({
        [errorKey]: 'Ogiltig IP-adress eller CIDR.'.translate(
          this.props.lang,
        ),
      });
      return;
    }

    if (this.state[listKey].indexOf(value) !== -1) {
      this.setState({ [inputKey]: '', [errorKey]: null });
      return;
    }

    this.setState({
      [listKey]: [...this.state[listKey], value],
      [inputKey]: '',
      [errorKey]: null,
    });
  };

  removeIp = (scope, ip) => {
    const listKey = scope + 'Ips';
    this.setState({
      [listKey]: this.state[listKey].filter((item) => item !== ip),
    });
  };

  renderIpField = (scope, disabled) => {
    const lang = this.props.lang;
    const ips = this.state[scope + 'Ips'];
    const input = this.state[scope + 'IpInput'];
    const error = this.state[scope + 'IpError'];

    return (
      <div className="field-wrap ip-whitelist-field">
        <label>{'IP-adresser'.translate(lang)}</label>
        <div className={error ? 'ip-chip-input required' : 'ip-chip-input'}>
          {ips.map((ip) => (
            <span className="ip-chip" key={ip}>
              {ip}
              {!disabled ? (
                <button
                  type="button"
                  onClick={() => this.removeIp(scope, ip)}
                >
                  &times;
                </button>
              ) : null}
            </span>
          ))}
          {!disabled ? (
            <input
              value={input}
              placeholder={'Lägg till IP-adress...'.translate(lang)}
              onChange={(e) =>
                this.setState({
                  [scope + 'IpInput']: e.target.value,
                  [scope + 'IpError']: null,
                })
              }
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ',') {
                  e.preventDefault();
                  this.addIp(scope);
                }
              }}
              onBlur={() => this.addIp(scope)}
            />
          ) : null}
        </div>
        {error ? <p className="form-error">{error}</p> : null}
        <p className="hint">
          {'Lämna tomt för åtkomst från valfri adress. Vi rekommenderar att du anger IP-adressen för servern som anropar API:et.'.translate(
            lang,
          )}
        </p>
      </div>
    );
  };

  // ---------- Create ----------

  openCreateModal = () => {
    this.setState({
      createModalOpen: true,
      createName: '',
      createIps: [],
      createIpInput: '',
      createIpError: null,
      createExpiresAt: null,
      createEnabled: true,
      createError: null,
    });
  };

  closeCreateModal = () => {
    this.setState({ createModalOpen: false });
  };

  submitCreate = () => {
    const lang = this.props.lang;

    if (!this.state.createName.trim()) {
      this.setState({ createError: 'Namn krävs.'.translate(lang) });
      return;
    }

    this.setState({ createSubmitting: true, createError: null });

    this.apiFetch('/account/api-keys/new', {
      method: 'POST',
      body: JSON.stringify({
        name: this.state.createName.trim(),
        ipWhitelist: this.state.createIps,
        isEnabled: this.state.createEnabled,
        expiresAt: this.state.createExpiresAt || null,
      }),
    })
      .then(({ status, json }) => {
        if (status >= 200 && status < 300) {
          this.setState({
            createSubmitting: false,
            createModalOpen: false,
            revealKey: json.apiKey,
            revealContext: 'create',
            revealSaved: false,
            revealCopied: false,
          });
          this.get();
          this.showSuccess(
            'Vi har skickat en bekräftelse till din e-post.'.translate(lang),
          );
        } else {
          this.setState({
            createSubmitting: false,
            createError:
              (json && json.error) ||
              'Något gick fel, försök igen.'.translate(lang),
          });
        }
      })
      .catch(() => this.setState({ createSubmitting: false }));
  };

  // ---------- Reveal (create / rotate) ----------

  closeRevealModal = () => {
    this.setState({
      revealKey: null,
      revealContext: null,
      revealSaved: false,
      revealCopied: false,
    });
  };

  copyRevealKey = () => {
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard
        .writeText(this.state.revealKey)
        .then(() => this.setState({ revealCopied: true }))
        .catch(() => {});
    }
  };

  // ---------- Edit ----------

  openEditModal = (key) => {
    this.setState({
      editKey: key,
      editName: key.name,
      editIps: key.ipWhitelist || [],
      editIpInput: '',
      editIpError: null,
      editExpiresAt: key.expiresAt || null,
      editEnabled: key.isEnabled,
      editError: null,
      editNeedsConfirm: false,
    });
  };

  closeEditModal = () => {
    this.setState({ editKey: null, editNeedsConfirm: false });
  };

  submitEdit = () => {
    const lang = this.props.lang;
    const key = this.state.editKey;

    if (!this.state.editName.trim()) {
      this.setState({ editError: 'Namn krävs.'.translate(lang) });
      return;
    }

    const usedRecently =
      key.lastUsedAt &&
      Date.now() - new Date(key.lastUsedAt).getTime() < 24 * 60 * 60 * 1000;
    const narrowed = isIpListNarrowed(key.ipWhitelist, this.state.editIps);
    const disabling = key.isEnabled && !this.state.editEnabled;

    if (usedRecently && (narrowed || disabling) && !this.state.editNeedsConfirm) {
      this.setState({ editNeedsConfirm: true });
      return;
    }

    this.performEditSave();
  };

  performEditSave = () => {
    const lang = this.props.lang;
    const key = this.state.editKey;

    this.setState({ editSubmitting: true, editError: null });

    this.apiFetch('/account/api-keys/' + key._id, {
      method: 'PUT',
      body: JSON.stringify({
        name: this.state.editName.trim(),
        isEnabled: this.state.editEnabled,
        ipWhitelist: this.state.editIps,
        expiresAt: this.state.editExpiresAt || null,
      }),
    })
      .then(({ status, json }) => {
        this.setState({ editSubmitting: false });

        if (status >= 200 && status < 300) {
          this.setState({ editKey: null, editNeedsConfirm: false });
          this.get();
        } else if (status === 404) {
          this.setState({ editKey: null, editNeedsConfirm: false });
          this.setState({
            listError: 'Nyckeln hittades inte.'.translate(lang),
          });
          this.get();
        } else {
          this.setState({
            editError:
              (json && json.error) ||
              'Något gick fel, försök igen.'.translate(lang),
          });
        }
      })
      .catch(() => this.setState({ editSubmitting: false }));
  };

  // ---------- Rotate ----------

  openRotateModal = (key) => {
    this.setState({
      rotateKey: key,
      rotateGrace: 1440,
      rotateError: null,
    });
  };

  closeRotateModal = () => {
    this.setState({ rotateKey: null });
  };

  submitRotate = () => {
    const lang = this.props.lang;
    const key = this.state.rotateKey;

    this.setState({ rotateSubmitting: true, rotateError: null });

    this.apiFetch('/account/api-keys/rotate/' + key._id, {
      method: 'POST',
      body: JSON.stringify({ graceMinutes: this.state.rotateGrace }),
    })
      .then(({ status, json }) => {
        this.setState({ rotateSubmitting: false });

        if (status >= 200 && status < 300) {
          this.setState({
            rotateKey: null,
            revealKey: json.apiKey,
            revealContext: 'rotate',
            revealSaved: false,
            revealCopied: false,
          });
          this.get();
          this.showSuccess(
            'Vi har skickat en bekräftelse till din e-post.'.translate(lang),
          );
        } else if (status === 404) {
          this.setState({
            rotateKey: null,
            listError: 'Nyckeln hittades inte.'.translate(lang),
          });
          this.get();
        } else {
          this.setState({
            rotateError:
              (json && json.error) ||
              'Något gick fel, försök igen.'.translate(lang),
          });
        }
      })
      .catch(() => this.setState({ rotateSubmitting: false }));
  };

  // ---------- Revoke ----------

  openRevokeModal = (key) => {
    this.setState({
      revokeKey: key,
      revokeConfirmInput: '',
      revokeError: null,
    });
  };

  closeRevokeModal = () => {
    this.setState({ revokeKey: null });
  };

  submitRevoke = () => {
    const lang = this.props.lang;
    const key = this.state.revokeKey;

    this.setState({ revokeSubmitting: true, revokeError: null });

    this.apiFetch('/account/api-keys/' + key._id, { method: 'DELETE' })
      .then(({ status, json }) => {
        this.setState({ revokeSubmitting: false });

        if (status >= 200 && status < 300) {
          this.setState({ revokeKey: null });
          this.get();
        } else if (status === 404) {
          this.setState({
            revokeKey: null,
            listError: 'Nyckeln hittades inte.'.translate(lang),
          });
          this.get();
        } else {
          this.setState({
            revokeError:
              (json && json.error) ||
              'Något gick fel, försök igen.'.translate(lang),
          });
        }
      })
      .catch(() => this.setState({ revokeSubmitting: false }));
  };

  // ---------- Render helpers ----------

  renderIpSummary = (key) => {
    const lang = this.props.lang;
    const list = key.ipWhitelist || [];
    if (list.length === 0) {
      return <span>{'Alla IP-adresser'.translate(lang)}</span>;
    }
    return (
      <span title={list.join('\n')}>
        {list.length +
          ' ' +
          (list.length === 1
            ? 'IP-adress'.translate(lang)
            : 'IP-adresser'.translate(lang))}
      </span>
    );
  };

  renderRow = (key) => {
    const lang = this.props.lang;
    const status = getKeyStatus(key, this.state.now);

    return (
      <tr key={key._id}>
        <td>
          <div>{key.name}</div>
          {key.createdVia === 'admin' ? (
            <small className="created-via">
              {'Skapad av administratör'.translate(lang)}
            </small>
          ) : null}
        </td>
        <td className="masked-key">{maskKey(key)}</td>
        <td>
          <span className={'status-badge ' + status.className}>
            {status.label.translate(lang)}
          </span>
          {status.code === 'expiring' ? (
            <div className="status-sub">
              {'Slutar fungera om'.translate(lang)} {status.remaining}
            </div>
          ) : null}
        </td>
        <td>{this.renderIpSummary(key)}</td>
        <td>
          {key.expiresAt
            ? moment(key.expiresAt).format('YYYY-MM-DD')
            : 'Aldrig'.translate(lang)}
        </td>
        <td>
          {key.lastUsedAt ? (
            <span>
              {moment(key.lastUsedAt).fromNow()}
              {key.lastUsedIp ? ' · ' + key.lastUsedIp : ''}
            </span>
          ) : (
            'Aldrig använd'.translate(lang)
          )}
        </td>
        <td>{moment(key.createdAt).format('YYYY-MM-DD')}</td>
        <td className="actions">
          <a onClick={() => this.openEditModal(key)}>
            {'Redigera'.translate(lang)}
          </a>
          {status.code === 'active' || status.code === 'disabled' ? (
            <a onClick={() => this.openRotateModal(key)}>
              {'Rotera'.translate(lang)}
            </a>
          ) : null}
          {status.code !== 'revoked' ? (
            <a
              className="danger"
              onClick={() => this.openRevokeModal(key)}
            >
              {'Återkalla'.translate(lang)}
            </a>
          ) : null}
        </td>
      </tr>
    );
  };

  renderCreateModal() {
    const lang = this.props.lang;

    return (
      <div className="api-key-modal">
        <div
          className="api-key-modal-overlay"
          onClick={this.closeCreateModal}
        ></div>
        <div className="api-key-modal-content">
          <div className="api-key-modal-header">
            <h4>{'Skapa API-nyckel'.translate(lang)}</h4>
            <button onClick={this.closeCreateModal}>&times;</button>
          </div>
          <div className="api-key-modal-body">
            <div className="field-wrap">
              <Text
                label={'Namn *'.translate(lang)}
                placeholder={'t.ex. ERP-server'.translate(lang)}
                value={this.state.createName}
                onChange={(e) =>
                  this.setState({ createName: e.target.value })
                }
              />
            </div>

            {this.renderIpField('create', false)}

            <div className="field-wrap">
              <label>{'Upphör'.translate(lang)}</label>
              <DatePicker
                value={this.state.createExpiresAt}
                placeholder={'Aldrig'.translate(lang)}
                onChange={(date) =>
                  this.setState({ createExpiresAt: date })
                }
              />
              {this.state.createExpiresAt ? (
                <a
                  className="clear-date"
                  onClick={() =>
                    this.setState({ createExpiresAt: null })
                  }
                >
                  {'Aldrig'.translate(lang)}
                </a>
              ) : null}
            </div>

            <div className="field-wrap">
              <Check
                label={'Aktivera direkt'.translate(lang)}
                value={this.state.createEnabled}
                onChange={(value) =>
                  this.setState({ createEnabled: value })
                }
              />
            </div>

            {this.state.createError ? (
              <p className="form-error">{this.state.createError}</p>
            ) : null}
          </div>
          <div className="api-key-modal-footer">
            <button
              className="button button-outline"
              onClick={this.closeCreateModal}
            >
              {'Avbryt'.translate(lang)}
            </button>
            <button
              className="button"
              disabled={this.state.createSubmitting}
              onClick={this.submitCreate}
            >
              {'Skapa nyckel'.translate(lang)}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderRevealModal() {
    const lang = this.props.lang;

    return (
      <div className="api-key-modal">
        <div className="api-key-modal-overlay"></div>
        <div className="api-key-modal-content">
          <div className="api-key-modal-header">
            <h4>{'Spara din nyckel'.translate(lang)}</h4>
          </div>
          <div className="api-key-modal-body">
            <p className="warning-text">
              {'Nyckeln visas bara nu. Om du tappar bort den måste du rotera den.'.translate(
                lang,
              )}
            </p>
            <div className="reveal-key-box">
              <span>{this.state.revealKey}</span>
              <button type="button" onClick={this.copyRevealKey}>
                {this.state.revealCopied
                  ? 'Kopierad!'.translate(lang)
                  : 'Kopiera'.translate(lang)}
              </button>
            </div>
            <div className="field-wrap">
              <Check
                label={'Jag har sparat nyckeln'.translate(lang)}
                value={this.state.revealSaved}
                onChange={(value) => this.setState({ revealSaved: value })}
              />
            </div>
          </div>
          <div className="api-key-modal-footer">
            <button
              className="button"
              disabled={!this.state.revealSaved}
              onClick={this.closeRevealModal}
            >
              {'Stäng'.translate(lang)}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderEditModal() {
    const lang = this.props.lang;
    const key = this.state.editKey;
    const status = getKeyStatus(key, this.state.now);
    const disabled = status.code === 'revoked';

    return (
      <div className="api-key-modal">
        <div
          className="api-key-modal-overlay"
          onClick={this.closeEditModal}
        ></div>
        <div className="api-key-modal-content">
          <div className="api-key-modal-header">
            <h4>{'Redigera API-nyckel'.translate(lang)}</h4>
            <button onClick={this.closeEditModal}>&times;</button>
          </div>
          <div className="api-key-modal-body">
            <div className="field-wrap">
              <Text
                label={'Namn *'.translate(lang)}
                value={this.state.editName}
                disabled={disabled}
                onChange={(e) => this.setState({ editName: e.target.value })}
              />
            </div>

            {this.renderIpField('edit', disabled)}

            <div className="field-wrap">
              <label>{'Upphör'.translate(lang)}</label>
              <DatePicker
                value={this.state.editExpiresAt}
                placeholder={'Aldrig'.translate(lang)}
                disabled={disabled}
                onChange={(date) => this.setState({ editExpiresAt: date })}
              />
              {this.state.editExpiresAt && !disabled ? (
                <a
                  className="clear-date"
                  onClick={() => this.setState({ editExpiresAt: null })}
                >
                  {'Aldrig'.translate(lang)}
                </a>
              ) : null}
            </div>

            <div className="field-wrap">
              <Check
                label={'Aktiverad'.translate(lang)}
                value={this.state.editEnabled}
                disabled={disabled}
                onChange={(value) => this.setState({ editEnabled: value })}
              />
            </div>

            {this.state.editNeedsConfirm ? (
              <p className="warning-text">
                {'Den här nyckeln har använts den senaste dagen. Att inaktivera den eller begränsa IP-listan gör att förfrågningar med den nekas direkt.'.translate(
                  lang,
                )}
              </p>
            ) : null}

            {this.state.editError ? (
              <p className="form-error">{this.state.editError}</p>
            ) : null}
          </div>
          <div className="api-key-modal-footer">
            <button
              className="button button-outline"
              onClick={this.closeEditModal}
            >
              {'Avbryt'.translate(lang)}
            </button>
            {!disabled ? (
              <button
                className={
                  this.state.editNeedsConfirm
                    ? 'button button-danger'
                    : 'button'
                }
                disabled={this.state.editSubmitting}
                onClick={this.submitEdit}
              >
                {this.state.editNeedsConfirm
                  ? 'Bekräfta ändå'.translate(lang)
                  : 'Spara'.translate(lang)}
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  renderRotateModal() {
    const lang = this.props.lang;

    return (
      <div className="api-key-modal">
        <div
          className="api-key-modal-overlay"
          onClick={this.closeRotateModal}
        ></div>
        <div className="api-key-modal-content">
          <div className="api-key-modal-header">
            <h4>{'Rotera API-nyckel'.translate(lang)}</h4>
            <button onClick={this.closeRotateModal}>&times;</button>
          </div>
          <div className="api-key-modal-body">
            <p>
              {'Du får en ny nyckel med samma inställningar.'.translate(lang)}{' '}
              {'Byt ut den i ditt system inom den valda tiden.'.translate(
                lang,
              )}
            </p>
            <div className="field-wrap">
              <Select
                label={'Hur länge ska den gamla nyckeln fortsätta fungera?'.translate(
                  lang,
                )}
                placeholder={'Välj...'.translate(lang)}
                value={this.state.rotateGrace}
                onChange={(value) =>
                  this.setState({ rotateGrace: Number(value) })
                }
              >
                <option value={0}>{'Direkt'.translate(lang)}</option>
                <option value={60}>{'1 timme'.translate(lang)}</option>
                <option value={1440}>{'24 timmar'.translate(lang)}</option>
                <option value={10080}>{'7 dagar'.translate(lang)}</option>
              </Select>
            </div>

            {this.state.rotateError ? (
              <p className="form-error">{this.state.rotateError}</p>
            ) : null}
          </div>
          <div className="api-key-modal-footer">
            <button
              className="button button-outline"
              onClick={this.closeRotateModal}
            >
              {'Avbryt'.translate(lang)}
            </button>
            <button
              className="button"
              disabled={this.state.rotateSubmitting}
              onClick={this.submitRotate}
            >
              {'Rotera nyckel'.translate(lang)}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderRevokeModal() {
    const lang = this.props.lang;
    const key = this.state.revokeKey;
    const canConfirm = this.state.revokeConfirmInput.trim() === key.name;

    return (
      <div className="api-key-modal">
        <div
          className="api-key-modal-overlay"
          onClick={this.closeRevokeModal}
        ></div>
        <div className="api-key-modal-content">
          <div className="api-key-modal-header">
            <h4>{'Återkalla API-nyckel'.translate(lang)}</h4>
            <button onClick={this.closeRevokeModal}>&times;</button>
          </div>
          <div className="api-key-modal-body">
            <p className="warning-text">
              {'Nyckeln slutar fungera omedelbart. Denna åtgärd kan inte ångras.'.translate(
                lang,
              )}
            </p>
            <div className="field-wrap">
              <Text
                label={(
                  'Skriv').translate(lang)+' "' + key.name + '" '+ ('för att bekräfta'
                ).translate(lang)}
                value={this.state.revokeConfirmInput}
                onChange={(e) =>
                  this.setState({ revokeConfirmInput: e.target.value })
                }
              />
            </div>

            {this.state.revokeError ? (
              <p className="form-error">{this.state.revokeError}</p>
            ) : null}
          </div>
          <div className="api-key-modal-footer">
            <button
              className="button button-outline"
              onClick={this.closeRevokeModal}
            >
              {'Avbryt'.translate(lang)}
            </button>
            <button
              className="button button-danger"
              disabled={!canConfirm || this.state.revokeSubmitting}
              onClick={this.submitRevoke}
            >
              {'Återkalla nyckel'.translate(lang)}
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const lang = this.props.lang;
    const visibleKeys = this.state.showRevoked
      ? this.state.keys
      : this.state.keys.filter(
          (key) => getKeyStatus(key, this.state.now).code !== 'revoked',
        );
    const atLimit = this.activeKeyCount() >= 10;

    return (
      <div className="account-page api-keys-page">
        <section className="test">
          <img
            src={
              typeof window !== 'undefined' && window.innerWidth < 768
                ? imageMobile
                : image
            }
          />
          <div className="test-content">
            <h1>{'MINA SIDOR'.translate(lang)}</h1>
          </div>
        </section>

        <Container>
          <Row>
            <Col lg="4">
              <AccountNav {...this.props} />
            </Col>
            <Col lg="8">
              <div className="account-container">
                <div className="api-keys-header">
                  <h3>{'API-nycklar'.translate(lang)}</h3>
                  {this.state.keys.length > 0 ? (
                    <span
                      title={
                        atLimit
                          ? 'Återkalla en nyckel för att skapa en ny.'.translate(
                              lang,
                            )
                          : ''
                      }
                    >
                      <button
                        className="button"
                        disabled={atLimit}
                        onClick={this.openCreateModal}
                      >
                        {'Skapa nyckel'.translate(lang)}
                      </button>
                    </span>
                  ) : null}
                </div>

                {this.state.successMessage ? (
                  <p className="form-success">{this.state.successMessage}</p>
                ) : null}
                {this.state.listError ? (
                  <p className="form-error">{this.state.listError}</p>
                ) : null}

                {this.state.loading ? (
                  <p>{'Laddar...'.translate(lang)}</p>
                ) : this.state.keys.length === 0 ? (
                  <div className="api-keys-empty">
                    <h6>
                      {'En API-nyckel ger åtkomst till vårt API från ditt ERP-system eller annan integration.'.translate(
                        lang,
                      )}
                    </h6>
                    <button className="button" onClick={this.openCreateModal}>
                      {'Skapa nyckel'.translate(lang)}
                    </button>
                    <Link to="/integration-guide">
                      {'Så här använder du nyckeln'.translate(lang)}
                    </Link>
                  </div>
                ) : (
                  <>
                    <div className="api-keys-toolbar">
                      <Check
                        label={'Visa återkallade'.translate(lang)}
                        value={this.state.showRevoked}
                        onChange={(value) =>
                          this.setState({ showRevoked: value })
                        }
                      />
                      <Link to="/integration-guide">
                        {'Så här använder du nyckeln'.translate(lang)}
                      </Link>
                    </div>
                    <div className="api-keys-table-wrap">
                      <table className="api-keys-table">
                        <thead>
                          <tr>
                            <th>{'Namn'.translate(lang)}</th>
                            <th>{'Nyckel'.translate(lang)}</th>
                            <th>{'Status'.translate(lang)}</th>
                            <th>{'IP-begränsning'.translate(lang)}</th>
                            <th>{'Upphör'.translate(lang)}</th>
                            <th>{'Senast använd'.translate(lang)}</th>
                            <th>{'Skapad'.translate(lang)}</th>
                            <th>{'Åtgärder'.translate(lang)}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {visibleKeys.map((key) => this.renderRow(key))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>

        {this.state.createModalOpen ? this.renderCreateModal() : null}
        {this.state.revealKey ? this.renderRevealModal() : null}
        {this.state.editKey ? this.renderEditModal() : null}
        {this.state.rotateKey ? this.renderRotateModal() : null}
        {this.state.revokeKey ? this.renderRevokeModal() : null}
      </div>
    );
  }
}

export default Page(AccountApiKeysPage);
